export { default } from './Registration.jsx';
